import React, { Component } from 'react';
import Firebase from 'firebase';
import emailjs from 'emailjs-com';
import config from '../res/config';
import '../css/styles.css';
import Menu from './menu';
import PYTHON from '../image/python.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Card } from 'reactstrap';
import GITHUB from '../image/github.png';
import FACEBOOK from '../image/facebook.png';
import INSTAGRAM from '../image/instagram.png';
import Linkedin from '../image/linkedin.png';
import { fn } from 'jquery';

class Form extends Component{
    
    constructor(){
        super();
        //Firebase.initializeApp(config);
        
       try{
        Firebase.initializeApp(config);
        
       }
       catch(err){
           console.log("ERREor");
       }
        this.state = {
            developers: []
          }
    }
    
    writeUserData = () => {
        Firebase.database().ref('/').set(this.state);
        console.log('DATA SAVED');
      }

     
      render() {
        const { developers } = this.state;
        
        return(
          <Menu className="container">
            <div data-AOS="fade-down" className="row mt-5 "> 
              <div className="col-12 " align="center">
                  <a href="github"><span><img className="icon" src={GITHUB}/></span></a>
                   <a href="linkedin"><span><img class="icon ml-4" src={Linkedin}/></span></a>
                   <a href="facebook"><span><img class="icon ml-4" src={FACEBOOK}/></span></a>
                   <a href="instagram"><span><img class="icon ml-4" src={INSTAGRAM}/></span></a>
                   </div>     
            </div>

            <div data-AOS="fade-down" className='row mt-1 ml-2' >
            
              <div className='col-xl-12 offset-md-2' >

              <h1>Contact Here</h1>
                <form  onSubmit={this.sendEmail(this.state)} onClick={this.handleSubmit} >
                  <div className="form-row">
                    <input type='hidden' ref='uid' />
                    <div className="form-group col-md-4">
                      <label>First Name</label>
                      <input type="text" ref='fname' className="form-control" placeholder="First Name" />
                    </div>
                    <div className="form-group col-md-4">
                      <label>Last Name</label>
                      <input type="text" ref='lname' className="form-control" placeholder="Last Name" />
                    </div>
                    <div className="form-group col-md-8">
                      <label>Message</label>
                      <textarea type="text" rows='3' ref='msg' className="form-control" placeholder="Message" />
                    </div>
                  </div>
                  <button type="submit" onClick={this.sendEmail} className="btn btn-primary">Submit</button>
                </form>
                
               
              </div>
              
              </div>
             
          </Menu>
        )
      }
     
      handleSubmit = (event) => {
        event.preventDefault();
        let fname = this.refs.fname.value;
        let lname = this.refs.lname.value;
        let msg = this.refs.msg.value;
        let uid = this.refs.uid.value;
      
        if (uid && fname && lname && msg){
          const { developers } = this.state;
          const devIndex = developers.findIndex(data => {
            return data.uid === uid 
          });
          developers[devIndex].fname = fname;
          developers[devIndex].lname = lname;
          developers[devIndex].msg = msg;
          this.setState({ developers });
        }
        else if (fname && lname && fname && msg ) {
          const uid = new Date().getTime().toString();
          const { developers } = this.state;
          developers.push({ uid, fname,lname, msg })
          this.setState({ developers });
        }
        
      }
      
      
      sendEmail(prop) {
        const { developers } = prop;
        const sender="";
        const reciver=""
        emailjs.send('service_lzfflre', 'template_ab91euk', {
            to_name:sender,
            from_name:reciver,
            message:"Msg from"+JSON.stringify(developers),
        }, 'user_lOx3kePNBIJEUXVj41DKj')
          .then((result) => {
              console.log(result);
          }, (error) => {
              console.log(error.text);
          });
          
      }
      
      
}

export default Form;